<script setup lang="ts">
import { ref, computed, onMounted, reactive, PropType } from "vue";
import {
    IonBackButton,
    IonButton,
    IonButtons,
    IonSpinner,
    IonIcon,
    IonContent,
    IonHeader,
    IonTitle,
    IonList,
    IonItem,
    IonLabel,
    IonNote,
    IonToolbar,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    InfiniteScrollCustomEvent,
    modalController,
} from "@ionic/vue";
import { checkmarkCircleOutline } from "ionicons/icons";
import { format, startOfWeek, addDays, set } from "date-fns";
import { it, se } from "date-fns/locale";
import { IWeekModel, weekFactory } from "@/types/week";

const props = defineProps({
    propWeek: {
        type: Object as PropType<IWeekModel>,
        default: () => weekFactory(),
        required: false,
    },
});
const weeks = ref<IWeekModel[]>([props.propWeek]);
const loading = ref(false);
const selectedWeekDate = ref<string>(props.propWeek.week);
const orderedWeeks = computed(() => weeks.value.sort((a, b) => (a.week < b.week ? 1 : a.week > b.week ? -1 : 0)));

const loadMore = (future: boolean, amount: number = 1) => {
    const futureSign = future ? 1 : -1;
    const referenceDate = future
        ? orderedWeeks.value[0].start
        : orderedWeeks.value[orderedWeeks.value.length - 1].start;

    console.log("Loading more weeks", future ? "future" : "past", amount, referenceDate);

    for (let i = 0; i < amount; i++) {
        const days = 7 * futureSign * (i + 1);
        const start = addDays(referenceDate, days);
        weeks.value.push(weekFactory(start));
    }
};

const onSelect = (week: any) => {
    selectedWeekDate.value = week.week;
};

// const loadPast = (event: InfiniteScrollCustomEvent) => {
//     for (let i = 0; i < 20; i++) {
//         loadMore(false);
//     }
//     event.target.complete();
// };

// const loadFuture = (event: InfiniteScrollCustomEvent) => {
//     for (let i = 0; i < 10; i++) {
//         loadMore(true);
//     }
//     event.target.complete();
// };

const scrollToSelected = () => {
    const selectedWeek = selectedWeekDate.value;
    const currentWeekIndex = weeks.value.findIndex((w) => w.week === selectedWeek);
    const currentWeekElement = document.querySelector(`.week-selector-item:nth-child(${currentWeekIndex + 1})`);
    if (currentWeekElement) {
        currentWeekElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });
    }
};

const submit = () => {
    const selectedWeek = weeks.value.find((w: IWeekModel) => w.week === selectedWeekDate.value);
    return modalController.dismiss(selectedWeek, "confirm");
};

const cancel = () => {
    return modalController.dismiss(null, "cancel");
};

onMounted(() => {
    loading.value = true;
    // wait both tasks to complete
    Promise.all([
        new Promise((resolve) => {
            setTimeout(() => {
                resolve(true);
            }, 100);
        }),
        new Promise((resolve) => {
            loadMore(true, 20);
            loadMore(false, 20);
            resolve(true);
        }),
    ]).then(() => {
        loading.value = false;
        setTimeout(() => {
            scrollToSelected();
        }, 0);
    });
});
</script>

<template>
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button :strong="true" @click="cancel">Chiudi</ion-button>
            </ion-buttons>
            <ion-title style="text-align: center">Seleziona settimana</ion-title>
            <ion-buttons slot="end">
                <ion-button :strong="true" @click="submit">Salva</ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content style="--background: var(--ion-item-background)">
        <ion-list v-show="!loading">
            <ion-item
                class="week-selector-item"
                v-for="w in orderedWeeks"
                :key="w.week"
                style="cursor: pointer"
                @click="onSelect(w)">
                <ion-label
                    :style="{ 'font-weight': w.week === selectedWeekDate ? 'bold' : '400' }"
                    style="text-transform: capitalize; user-select: none"
                    :color="w.week === selectedWeekDate ? 'primary' : ''">
                    {{ w.label }}
                    <ion-note>{{ w.year_label }}</ion-note>
                </ion-label>
                <ion-icon
                    v-if="w.week === selectedWeekDate"
                    :icon="checkmarkCircleOutline"
                    color="primary"
                    slot="end"></ion-icon>
            </ion-item>
        </ion-list>
        <div
            v-show="loading"
            class="ion-text-center"
            style="margin-top: 20px; width: 100%; display: flex; justify-content: center">
            <ion-spinner name="crescent" style="margin: 20px auto; display: block"></ion-spinner>
        </div>
    </ion-content>
</template>
